import styled from "styled-components";
import { PrimaryButton } from "@loanbossinc/component-library";

export const StyledPrimaryButton = styled(PrimaryButton)`
  &&&{
    box-shadow: none;
    margin-top: 24px;
    margin-bottom: 88px;
  }
`;

export const StyledInfo = styled.div`
  //styleName: Work Sans /  16 Regular;
  font-family: Work Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const PaddedWrapper = styled.div`
  margin: 64px 24px;
  width: 528px;
`;

export const NoteHeader = styled.div`
  display:flex;
  flex-flow:row;
  align-items:center;
  justify-content:space-between;
  margin-bottom:56px;
`;

export const Title = styled.div`
  //styleName: Work Sans / 24;
  font-family: Work Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 12px;
`;

export const EmptyNoteWrapper = styled.div`
  height: 294px;
  width: 294px;
  left: 989px;
  top: 467px;
  border-radius: 50%;
  background: linear-gradient(217.82deg, rgba(79, 129, 157, 0.1) 6.94%, rgba(249, 249, 249, 0) 90.56%);
`;

export const ImageContainer = styled.div`
  text-align: center;
  display: block;
  margin-top: 65px;
`;

export const NoNotesTextWrapper = styled.div`
  /* No notes attached to this deal */
  width: 240px;
  height: 19px;

  /* Work Sans / 16 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  /* identical to box height */
  display: flex;
  align-items: center;
  text-align: right;

  /* Fill / Dark Gray */
  color: #5F6368;  
`;
